import { forwardRef, useCallback, useEffect, useState } from 'react'
import { useReadZipcode } from '@/api/accounting-dealer/person'
import { CepResponse } from '@/types'
import {
  CircularProgress,
  InputAdornment,
  Link,
  TextFieldProps,
} from '@mui/material'
import { removeNonNumeric, validateCep } from '@/helpers'
import { MaskedInput } from '../masked-input/masked-input'
import { ErrorOutline } from '@mui/icons-material'

export type CepSearchFieldProps = TextFieldProps & {
  onFindCep: (cep: CepResponse) => void
}

export const CepSearchField = forwardRef<HTMLInputElement, CepSearchFieldProps>(
  ({ onFindCep, ...props }, ref) => {
    const [validCep, setValidCep] = useState('')

    const {
      data: cep,
      isLoading,
      isError,
    } = useReadZipcode(removeNonNumeric(validCep), {
      enabled: !!validCep,
    })

    const handleInputZipcode = useCallback(
      async (event: React.ChangeEvent<HTMLInputElement>) => {
        const zipcode = event.target.value

        if (validateCep(zipcode)) {
          setValidCep(zipcode)
        } else {
          setValidCep('')
        }
      },
      [],
    )

    const helperText = props.helperText || (
      <Link
        href="https://buscacepinter.correios.com.br"
        target="_blank"
        rel="noopener"
      >
        Não sei meu CEP
      </Link>
    )

    useEffect(() => {
      if (cep) {
        onFindCep(cep)
      }
    }, [cep])

    return (
      <MaskedInput
        ref={ref}
        type="tel"
        mask="00000-000"
        onInput={handleInputZipcode}
        disabled={isLoading || props.disabled}
        helperText={helperText}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="start">
                {isLoading && <CircularProgress size={20} />}
                {isError && <ErrorOutline color="error" />}
              </InputAdornment>
            ),
          },
        }}
        {...props}
      />
    )
  },
)
